	<script src="http://www.zjdpf.org.cn/module/jslib/jquery/jquery.js"></script>
	<script type="text/javascript">
	$(document).ready(function(){
		var duilian2 = $("div.duilian2");
		var duilian2_close = $("a.duilian2_close");
		var window_w = $(window).width();
		if(window_w>1000){duilian2.show();}
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			duilian2.stop().animate({top:scrollTop+220});
		});
		duilian2_close.click(function(){
			$(this).parent().hide();
			return false;
		});
	});
	</script>
	<style type="text/css">
	.duilian2,.duilian{
		height:200px;
		background: #BD0100;
		width:200px;
	}
	.duilian2{top:345px;position:absolute;overflow:hidden; display:none;}/**200px>345px;*/
	.duilian2_left{ left:6px;}
	.duilian2_right{right:6px;}
	.duilian2_con{overflow:hidden;}
	.duilian2_close{ width:100%; height:24px; line-height:24px; text-align:right; display:block; font-size:13px; color:#555555; text-decoration:none;}
	</style>
<template>
<div>
    <div class="footer">
        <p class="copy-text">地址:驻马店市泰山路529号广泰大厦四楼(463000) 电话:0396-2806728 / 2806729 传真:0396-2806728 邮箱:zmdsclxxzx@163.com</p>
        <p class="text-1">版权所有 驻马店市残疾人联合会  <a href="https://beian.miit.gov.cn/#/Integrated/index"> 豫ICP备11012299号</a>
        <span><img src="../../../assets/img/gongan.png"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41170202000513&amp;" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;" target="_blank"> 豫公网安备 41170202000513号</a> &nbsp;&nbsp;&nbsp;&nbsp;</span> </p>
    </div>
	  <div class="left-pic" v-if="showV">
      <img src="../../../assets/img/008.jpg" alt="" @click="linkTo008">
      <img src="../../../assets/img/007.jpg" alt="" @click="linkTo">
    </div>
    <div class="right-pic" v-if="showV" >
      <img src="../../../assets/img/006.png" alt="">
    </div>
    <!-- <div v-if="showV" class="duilian2 duilian2_left" style="display: block;">
	    <div class="duilian2_con"><a href="http://cljs.cnki.net" target="_blank"><img src="../../../assets/img/flzzjs.jpg" border="0" width = "200px" height="200px"></a></div>
		  <a class="duilian2_close" href="#">关闭</a>
	  </div> -->
</div>
</template>

<script>
export default {
  name: 'bottomfooter',
  components: {},
  data() {
    return {
        showV:false
    };
  },
  mounted() {
    if (this._isMobile()) {
      //console.log('mobile')
      this.showV = false;
    } else {
      //console.log("pc端");
      this.showV = false;
    }
  },
  methods: {
    _isMobile() {
    	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    	 return flag;
    },
    linkTo(){
    	window.open('https://www.chinadata.cn/', '_blank');
    },
    linkTo008(){
    	window.open('http://www.legaldaily.com.cn/IT/node_107001.html', '_blank');
    }
  }
};
</script>

<style scoped>
  .footer {
    text-align: center;
    padding: 20px 0;
    background: #199352;
  }
  .footer p {
    font-size: 14px;
    color:#fff;
    line-height:22px;
  }

  .footer p a{
    font-size: 14px;
    color:#fff;
    line-height:22px;
  }
  .right-pic{
    width:142px;
    height:330px;
    position:fixed;
    right:10px;
    top:345px;/** 100px > 345px*/
    z-index: 999;
  }
  .left-pic img{
   	cursor:pointer;
   	width:400px;
    height:165px;
  }
  .left-pic{
    width:400px;
    height:165px;
    position:fixed;
    left:10px;
    top:345px;/** 100px > 345px*/
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/views/front/components/bottomfooter.vue